import { jsxs as s, jsx as e } from "@emotion/react/jsx-runtime";
import { Fragment as u } from "react";
import { useTheme as f } from "@emotion/react";
import { Checkbox as h } from "@partoohub/ui";
import { StyledSeparator as g } from "../GroupsContent.styled.js";
import { StyledStack as b, EllipsisText as S } from "../Section/Section.styled.js";
import { useBusinessModalContext as k } from "../../../BusinessModalContext.js";
import { NO_GROUP_ID as o } from "../../../reducer/businessModal.reducer.js";
import { selectGroup as x } from "../../../reducer/businessModal.actions.js";
const w = ({
  hasGroups: i = !1
}) => {
  const n = f(), {
    dispatch: l,
    preFilters: c,
    readOnlyFilters: a,
    translations: d
  } = k(), t = a?.enabledGroupIds ?? [], r = t.length !== 0 && !t.includes(o), p = c?.selectedGroupIds?.includes(o.toString()) ?? !1, m = () => {
    r || l(x(o.toString()));
  };
  return /* @__PURE__ */ s(u, { children: [
    i && /* @__PURE__ */ e(g, { color: n.colors.default.alpha }),
    /* @__PURE__ */ s(b, { onClick: m, justifyContent: "space-between", direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ e(S, { variant: "heading6", children: d.ungrouped }),
      /* @__PURE__ */ e(h, { dataTrackId: "group_section__checkbox", "aria-label": "", checked: p, disabled: r })
    ] })
  ] }, "no-group");
};
export {
  w as NoGroupSection
};
